<template>
    <div class="form-send-message">
        <div class="discussion-preview-div" v-if="files.length != 0">
            <ul class="discussion-preview">
                <li v-for="(item, key) in files" :key="key" @click="clearInputFile(item.url)">
                <i class="fa-solid fa-circle-xmark"></i>
                <img class="discussion-preview-image" :src="item.url" />
                </li>
            </ul>
        </div>

        <div id="send">
           
         
            <div class="footer-form-send">
                <div class="left">
                    <label class="upload-file" v-if="activeMedia">
                        <i class="fa-regular fa-paperclip"></i>
                        <input ref="inputFiles" hidden type="file" id="attachment" name="attachment" class="inputfile form-control" :accept="acceptTypeMedia" @change="addPreviewFiles"/>
                    </label>

                    <span class="emoji-trigger" :class="{ triggered: showEmojiPicker }" @click="toggleEmojiPicker()">
                        <picker :data="emojiIndex" v-show="showEmojiPicker" title="Pick your emoji..." emoji="point_up" @select="addEmoji"/>
                        <i class="fa-regular fa-face-smile"></i>
                    </span>
                </div>
                <div class="middle">
                    <div class="container-textarea">
                        <textarea @input="resize()" id="textmessage" height="80px" width="100%" v-model="message" ref="inputmessage"></textarea>
                    </div>
                </div>
                <div class="right">
                    <i class="fa-regular fa-paper-plane-top" @click="onSubmitMessage"></i>
                </div>
            </div>
        </div>
    </div>
     <!--@keyup.enter.native="onSubmitMessage"-->
</template>

<script>

import { Picker, EmojiIndex } from 'emoji-mart-vue-fast'
import emojiData from '@/constants/emoji-mart-vue-fast/all.json'


    export default {
        props: {  
            activeMedia : {
                type: Boolean,
                default: true
            },
            acceptTypeMedia : {
                type: String,
                default: "video/*, image/*"
            },
            setAutofocus : { 
                type: Boolean,
                default: false
            }
        },


        components: {
            Picker,
        },

        watch: {
            setAutofocus() {
                if(this.setAutofocus && this.$refs.inputmessage) {
                    this.$refs.inputmessage.focus()
                    this.$emit('autoFocused', true)
                }
            }
        },

        data() {
            return {
                message: '',
                files : [],
                showEmojiPicker : false,
                emojiIndex: new EmojiIndex(emojiData),
            }
        },

        methods: {
            resize() {
                let element = this.$refs["inputmessage"];

                element.style.height = "18px";
                element.style.height = element.scrollHeight + "px";
            },
 
            onSubmitMessage(e) {
                let formData = new FormData()
                if (this.message && this.message.length) {
                    formData.append('message', this.message)
                }

                for (var i = 0; i < this.files.length; i++) {
                    formData.append("file[]", this.files[i].file);
                }
                console.log("formData |||||| ",formData)
                
                this.$emit('onSubmitMessage', formData, this.files.map((file) => file.url))
                this.message = null
                this.files = []
            },

            addPreviewFiles(event) {
                for (var file of event.target.files) {
                    // this.files.push({
                    //     url : URL.createObjectURL(file),
                    //     file : file
                    // })

                    this.files = [{
                        url : URL.createObjectURL(file),
                        file : file
                    }]
                }

               
                this.$refs.inputFiles.value = ""
            },

            clearInputFile(url) {
                this.files = this.files.filter(file => file.url !== url)
            },

            // Method for Emoji
            toggleEmojiPicker() {
                this.showEmojiPicker = !this.showEmojiPicker
            },

            hideEmojiPicker() {
                this.showEmojiPicker = false
            },

            addEmoji(emoji) {
                const cursorPosition = this.getInputSelection(this.$refs.inputmessage)
                this.message = this.message ? this.message : ''
                const start = this.message.substring(0, cursorPosition.start)
                const end = this.message.substring(cursorPosition.end)
                this.message = start + emoji.native + end
                console.log('emoji added:', this.message)
                this.$refs.inputmessage.focus()
                this.$nextTick(() => {
                    this.$refs.inputmessage.selectionStart = (start + emoji.native).length
                    this.$refs.inputmessage.selectionEnd = (start + emoji.native).length
                });
                this.hideEmojiPicker()
            },

            getInputSelection(el) {
            var start = 0,
                end = 0,
                normalizedValue,
                range,
                textInputRange,
                len,
                endRange

            if (
                typeof el.selectionStart == 'number' &&
                typeof el.selectionEnd == 'number'
            ) {
                start = el.selectionStart
                end = el.selectionEnd
            } else {
                range = document.selection.createRange()

                if (range && range.parentElement() == el) {
                len = el.value.length
                normalizedValue = el.value.replace(/\r\n/g, '\n')

                // Create a working TextRange that lives only in the input
                textInputRange = el.createTextRange()
                textInputRange.moveToBookmark(range.getBookmark())

                // Check if the start and end of the selection are at the very end
                // of the input, since moveStart/moveEnd doesn't return what we want
                // in those cases
                endRange = el.createTextRange()
                endRange.collapse(false)

                if (textInputRange.compareEndPoints('StartToEnd', endRange) > -1) {
                    start = end = len
                } else {
                    start = -textInputRange.moveStart('character', -len)
                    start += normalizedValue.slice(0, start).split('\n').length - 1

                    if (textInputRange.compareEndPoints('EndToEnd', endRange) > -1) {
                    end = len
                    } else {
                    end = -textInputRange.moveEnd('character', -len)
                    end += normalizedValue.slice(0, end).split('\n').length - 1
                    }
                }
                }
            }

            return {
                start: start,
                end: end
            }
            },
        },
    }
</script>
